import React, {
  useMemo,
  useCallback,
  useContext,
  useState,
  useEffect,
} from "react";
import PropTypes from "prop-types";
import { UserContext } from "context/user";
import { getFarm } from "api/Farm";
import Table from "components/Table";
import Button from "components/Button";
import NameCell from "./components/NameCell";
import RoleCell from "./components/RoleCell";
import ActionCell from "./components/ActionCell";
import "./index.scss";

const CollaboratorsContainer = ({
  farm,
  handleShareFarm,
  handleDeleteModal,
}) => {
  const { token } = useContext(UserContext);
  const [farmData, setFarmData] = useState([]);

  const fetchData = useCallback(async () => {
    if (!token) return;

    const currentPath = window.location.pathname.split("/");
    let farmID = "";

    if (currentPath[1] === "farms" && currentPath[3] === "details") {
      const farmIdx = 2;
      farmID = currentPath[farmIdx];
    }
    const farmDetails = await getFarm(farmID, token);
    setFarmData(farmDetails?.properties?.collaborators);
  }, [token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "email",
        Cell: (props) => <NameCell {...props} />,
      },
      {
        Header: "Role",
        accessor: "permission",
        Cell: (props) => <RoleCell {...props} />,
      },
      {
        Header: "Action",
        Cell: (props) => (
          <ActionCell
            {...props}
            deleteCollaborator={(e) => handleDeleteModal(e)}
          />
        ),
      },
    ],
    [handleDeleteModal]
  );

  return (
    <div data-testid="collaborators-details" className="collaborators-details">
      <div className="actions-wrapper">
        <div className="left">
          <Button
            data-testid="invite-collaborator"
            type="solid"
            color="green"
            size="normal"
            label="Invite Collaborator"
            icon="add"
            onClick={() => handleShareFarm()}
          />
        </div>
      </div>
      <Table
        data={farm?.properties?.collaborators || farmData}
        columns={columns}
        isPaginated={false}
      />
    </div>
  );
};

CollaboratorsContainer.propTypes = {
  farm: PropTypes.oneOfType([PropTypes.object]),
  handleShareFarm: PropTypes.func.isRequired,
  handleDeleteModal: PropTypes.func.isRequired,
};

CollaboratorsContainer.defaultProps = {
  farm: {},
};

export default CollaboratorsContainer;
